<template>
  <v-card width="100%" flat tile>
    <v-card-title>
      <h3 class="text-h4">Transactions</h3>
      <v-spacer></v-spacer>

      <div>
        <span class="text-h5"> {{ balance.total }} : </span>

        <span class="success--text text-h5">
          {{ balance.processed }}
        </span>
        <span class="text-h5">
          |
        </span>
        <span class="error--text text-h5">
          {{ balance.remaining }}
        </span>
      </div>

      <v-spacer></v-spacer>

      <v-dialog persistent v-model="dialog">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="modelPermissions.create && !payAsYouGo"
            class="mb-auto"
            dark
            fab
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon></v-btn
          >
        </template>
        <transaction-dialog
          :client_id="client_id"
          v-if="dialog"
          :transactions="transactions"
          :item="item"
          :close="close"
        ></transaction-dialog>
      </v-dialog>
    </v-card-title>

    <v-data-table
      :server-items-length="transactions.total"
      :loading="loading"
      :headers="getHeaders"
      :items="transactions.data"
      :options.sync="options"
      :items-per-page="5"
    >
      <template v-slot:item.first="{ item }">
        <p
          class="my-auto font-weight-bold"
          :class="{
            'success--text': item.first === 1,
            'error--text': item.first === 0
          }"
        >
          {{ item.first === 0 ? 'N' : 'Y' }}
        </p>
      </template>
      <template v-slot:item.last="{ item }">
        <p
          class="my-auto font-weight-bold"
          :class="{
            'success--text': item.last === 1,
            'error--text': item.last === 0
          }"
        >
          {{ item.last === 0 ? 'N' : 'Y' }}
        </p>
      </template>
      <template v-slot:item.paid="{ item }">
        <p
          class="my-auto font-weight-bold"
          :class="{
            'success--text': item.paid === 1,
            'error--text': item.paid === 0
          }"
        >
          {{ item.paid === 0 ? 'N' : 'Y' }}
        </p>
      </template>

      <!-- <template v-slot:item.process="{ item }">
        <v-btn
          v-if="item.paid === 0"
          text
          @click="processPayment(item)"
          color="primary"
        >
          process
        </v-btn>
      </template> -->

      <template v-if="modelPermissions.edit" v-slot:item.edit="{ item }">
        <v-btn text @click="editItem(item)" color="primary">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
        <v-btn text @click="deleteItem(item)" color="error">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.invoice="{ item }">
        <v-btn text @click="viewInvoice(item)" color="secondary">
          <v-icon left>mdi-receipt</v-icon>invoice
        </v-btn>
      </template>
    </v-data-table>

    <v-card-actions>
      <v-btn color="primary" @click="_changeModel(3)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="_changeModel(5)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { axios, Strings } from '../../../../utils'
import TransactionDialog from './TransactionDialog'
export default {
  props: ['changeModel', 'client_id', 'showMessage'],
  components: {
    TransactionDialog
  },

  data() {
    return {
      dialog: false,
      loading: false,

      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Transaction Date',
          align: 'start',
          value: 'transaction_date'
        },
        {
          text: 'Amount',
          align: 'start',
          value: 'amount'
        },
        {
          text: 'First',
          align: 'start',
          value: 'first'
        },
        {
          text: 'Last',
          align: 'start',
          value: 'last'
        },
        {
          text: 'Paid',
          align: 'start',
          value: 'paid'
        },
        { text: 'Edit', align: 'center', value: 'edit', sortable: false }

        // { text: 'Delete', align: 'center', value: 'delete', sortable: false }
        // { text: 'Process', align: 'center', value: 'process', sortable: false }
      ],
      transactions: [],
      balance: {
        total: 0,
        processed: 0,
        remaining: 0
      },
      options: {},
      item: {},
      search: ''
    }
  },

  methods: {
    _changeModel(index) {
      this.changeModel(index)
    },
    close() {
      this.item = {}
      this.getTransactions()
      this.dialog = false
    },
    editItem(item) {
      this.item = item
      this.dialog = true
    },
    getTransactions() {
      this.loading = true
      console.log('getting transactions')

      if (this.client_id != null) {
        axios
          .get(
            `api/admin/transactions/${
              this.payAsYouGo === true ? 'payg' : 'normal'
            }?page=${this.options.page}&itemsPerPage=${
              this.options.itemsPerPage
            }&client_id=${this.client_id}&payAsYouGo=${this.payAsYouGo}`
          )
          .then(res => {
            this.transactions = res.data
            console.log('done')
          })
          .catch(e => console.log(e))
          .finally(() => (this.loading = false))

        console.log('getting balance')
        axios
          .get(`api/admin/transactions/balance?client_id=${this.client_id}`)
          .then(res => {
            this.balance = res.data
            console.log('done')
          })
          .catch(e => console.log(e))
      }
    },
    deleteItem(item) {
      if (confirm(`Confirm Delete...${item.id}`)) {
        console.log('deleting transaction with id ', item.id)
        axios
          .delete(`api/admin/transactions/${item.id}`)
          .then(res => {
            console.log(res)
            if (res.data === 1) {
              this.getTransactions()
            }
          })
          .catch(err => console.log(err))
      }
    },
    processPayment(item) {
      this.loading = true
      axios
        .get(
          `api/admin/process-payment?client_id=${this.client_id}&transaction_id=${item.id}`
        )
        .then(res => {
          console.log(res)
          if (res.data.status === 'No payment method') {
            this.showMessage(res.data.status, 'error')
          }
          if (res.data.status === 'success') {
            this.showMessage(res.data.status, 'success')
            this.getTransactions()
          }
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false))
    },
    viewInvoice(item) {
      window.open(
        `${Strings.baseUrl}/pay-as-you-go-invoice?transaction_id=${item.id}&date=${item.transaction_date}`,
        '_blank'
      )
    }
  },

  computed: {
    ...mapGetters(['permissions/getModelPermissions']),

    ...mapState({ payAsYouGo: state => state.clients.payAsYouGo }),
    modelPermissions() {
      return this['permissions/getModelPermissions']('transaction')
    },
    getHeaders() {
      return this.payAsYouGo
        ? [
            ...this.headers,
            {
              text: 'Invoice',
              align: 'center',
              value: 'invoice',
              sortable: false
            }
          ]
        : [
            ...this.headers,
            {
              text: 'Delete',
              align: 'center',
              value: 'delete',
              sortable: false
            }
          ]
    }
  },
  watch: {
    options: {
      handler() {
        this.getTransactions()
      },
      deep: true
    },
    dialog: {
      handler() {
        this.getTransactions()
      },
      deep: true
    },
    client_id: {
      handler() {
        this.getTransactions()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
